import { FormControl, MenuItem, Select } from "@mui/material";
import { max } from "date-fns";
import React, { useEffect, useState } from "react";

const styles = {
  select: {
    backgroundColor: "#FFF",
    borderRadius: "4px",
    width: "96%",
    margin: "4px",
    maxWidth: "380px",
    boxShadow:
      "0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)",
  },
};

const TableSelect = (props) => {
  const [selectValue, setSelectValue] = useState(props.selctedData || "");

  const handleChange = (value) => {
    console.log(value);
    setSelectValue(value);
    props.onChange(value);
  };

  useEffect(() => {
    if (props.selctedData) {
      handleChange(props.selctedData);
    }
  }, [props.selctedData]);

  const { data, labelField } = props;

  return (
    <FormControl style={styles.select}>
      <Select
        labelId="demo-select-small-label"
        id="demo-select-small"
        value={selectValue}
        onChange={(e) => handleChange(e.target.value)}
        style={{ width: "100%", padding: "0px 8px", height: '32px', fontFamily: "Poppins" }}
        variant="outlined"
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
        }}
      >
        {data &&
          data?.length > 0 &&
          data.map((d) => (
            <MenuItem
              value={d}
              style={{
                width: "100%",
                fontFamily: "Poppins",
                textAlign: "left",
                padding: "4px 16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              {d}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default TableSelect;
